import React from "react";
import Card from "components/card";
import Button from "components/button";
import { Send } from "lucide-react";

const FilterToolBar = ({
    filters = [],
    activeFilter,
    onFilterChange,
    onActionClick
}) => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 dark-mode-card">
            <div className="pb-6 p-4">
                <div className="flex flex-col md:flex-row md:items-center gap-4 justify-between">
                    <div className="flex flex-wrap items-center gap-2">
                        {filters.map((filter) => {
                            const isActive = activeFilter === filter.value;

                            return (
                                <span
                                    key={filter.value}
                                    onClick={() => onFilterChange?.(filter.value)}
                                    className={`
                                        inline-flex items-center gap-1 px-3 py-1 text-xs font-medium border rounded-lg cursor-pointer transition-all
                                        ${
                                        isActive
                                            ? `text-white bg-gradient-to-r ${filter.bg ?? "from-purple-600 to-emerald-600"}`
                                            : "text-slate-900 hover:bg-slate-100 dark:text-slate-50 dark:hover:bg-slate-900"
                                        }
                                    `}
                                    >
                                    {filter.icon && <span className="mr-1">{filter.icon}</span>}
                                    {filter.label}
                                </span>
                            );
                        })}
                    </div>
                    <Button 
                        onClick={onActionClick}
                        className="inline-flex items-center justify-center gap-2 rounded-lg text-sm font-medium transition-all shrink-0 text-white hover:shadow-none h-9 px-4 py-2 bg-gradient-to-r from-purple-600 to-emerald-600 hover:from-purple-700 hover:to-emerald-700 whitespace-nowrap"
                    >
                        <Send className="w-4 h-4 mr-2"/>
                        Give Recognition
                    </Button>
                </div>
            </div>
        </Card>
    );
};

export default FilterToolBar;